import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-pro-wa-line-chart',
	templateUrl:'./WaLineChartProPage.html',
	styles: [],
	styleUrls:['./WaLineChartProPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaLineChartProPage
{
	mdContent_373 = `\`\`\`java
import com.jwebmp.webawesomepro.components.chart.WaLineChart;
\`\`\``;
	mdContent_374 = `\`\`\`java
new WaLineChart<>()
\`\`\``;
	mdContent_375 = `\`\`\`java
var chart = new WaLineChart<>();
chart.setLabel("User Growth");
chart.setXAxisLabel("Month");
chart.setYAxisLabel("Users");
\`\`\``;
}
